import styled from 'styled-components';

export const Canvas = styled.canvas`
  border: 10px solid black;
  width: 800px;
  height: 400px;
  box-sizing: border-box;
  border-image-slice: 1;
  border-image-source: linear-gradient(to left, #743ad5, #d53a9d);
`;
